import React from "react";
import { clubAndAssociationServiceId } from "../../../constants";
import ServiceFrontCommon from "../ServiceFrontCommon";

const ClubAssociation = () => {
  return (
    <ServiceFrontCommon
      serviceId={clubAndAssociationServiceId}
      serviceName="clubassociation"
      title="Club Association"
    />
  );
};

export default ClubAssociation;
